import { render } from "./updateUser.vue?vue&type=template&id=6da58274&scoped=true"
import script from "./updateUser.vue?vue&type=script&lang=js"
export * from "./updateUser.vue?vue&type=script&lang=js"

import "./updateUser.vue?vue&type=style&index=0&id=6da58274&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da58274"]])

export default __exports__